<div #text class="text-nowrap text-truncate">
    <span tooltipClass="custom-tooltip" container="body" [ngbTooltip]="showTooltip ? value : null"
    class="text-truncate">
    <ng-content></ng-content>
    </span>

</div>

